import { Box, Button } from '@mui/material'
import { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import Datepicker from '../../../common/datePicker'
import DropDownOA from '../../../common/dropDownOA'
import { appendToUrl, removeDuplicatesFromArray, focusElemnt, isEmpty, navigation3 } from '../../../common/helper'
import { Item } from '../../../common/snippets'
import { SplitButton } from '../../../common/SplitButton'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import { RefreshSvg } from '../../../common/svg/refresh'
import { ReportHeading } from '../common/ReportHeading'
import * as id from '../reportId'
import * as lb from '../reportLables'
import * as urls from '../oldReportsUrls'
import moment from 'moment/moment'
import { paymentModesWithAll } from '../../../common/paymentsMode'
import { reportOptionSum, reportOptionDet, reportViewData, lrDetailsColumns, excelHeader, lrDetailsDataFormat, paymentWiseAddTotal, paymentWiseColumns, addTotal, sourceCityCol, SNCol, headerColumns, destCityCol, destBranchCol, groupData, sourceBranchCol } from './constants'
import LRDetails from './LRDetails'
import { GetRequest } from '../../../common/api'
import { urls as urls2 } from '../../../common/constants'
import { useAtom, useSetAtom } from 'jotai'
import { alertAtom, globalLoaderAtom } from '../../../common/jotaiState/globalStateAtoms'
import DropDownMultiSelectV2 from '../../../common/dropDownMultiSelectV2'
import SummaryReport from './summaryReport'
import { CargoRoleRightsAtom, companySettingsAtom } from '../../../common/jotaiState/commonStateAtoms'
import { useSearchParams } from 'react-router-dom'
import useToken from '../../../helpers/useTokens'
import { downloadMultiTablePDF, downloadPDF } from './pdfAutotable'
const AnalysisReport = (props) => {
  const reportName = 'Analysis'
  const { data } = props
  const { common } = data
  const { loader } = common
  const [companySettings] = useAtom(companySettingsAtom)
  const effectiveCompanySettings = companySettings?companySettings:common?.companySettings?common?.companySettings?.[0]:{}
  let {UseToPayAsCOD, DefaultCurrencyID, UseFormattedLRinReports} = effectiveCompanySettings  ||{}
  const [cargoRoleRights] = useAtom(CargoRoleRightsAtom)
  const setLoader = useSetAtom(globalLoaderAtom)
  const { Table1: RoleRightTable1 = [] } = cargoRoleRights
  const [roleRightsData] = RoleRightTable1
  let { AllowViewAllBranchReport, AllowBranchInchargeRights, AllowExportExcel, AllowViewAllBranchOfCityReport } = { ...roleRightsData }
  const [fromDate, setFromDate] = useState(moment(new Date()))
  const [toDate, setToDate] = useState(moment(new Date()))
  const [selSourceCity, setSelSourceCity] = useState('')
  const [sourceCityData, setSourceCityData] = useState([])
  const [selSourceBranch, setSelSourceBranch] = useState('')
  const [sourceBranchData, setSourceBranchData] = useState([])
  const [selDestinationCity, setSelDestinationCity] = useState('')
  const [destinationCityData, setDestinationCityData] = useState([])
  const [selDestinationBranch, setSelDestinationBranch] = useState('')
  const [destinationBranchData, setDestinationBranchData] = useState([])
  const [paymentType, setPaymentType] = useState(paymentModesWithAll?.[0])
  const [reportView, setReportView] = useState(reportViewData?.[0])
  const [reportOptions, setReportOptions] = useState(reportOptionDet)
  const [reportOptionsData, setReportOptionsData] = useState(reportOptionDet)
  const [showTable, setShowTable] = useState(false)
  const [showTableData, setShowTableData] = useState({})
  const [disableBtn, setDisableBtn] = useState(false)
  const [disableExcel, setDisableExcel] = useState(false)
  const [, setAlert] = useAtom(alertAtom)
  const [searchParams] = useSearchParams()
  let { loginData = {} } = useToken()
  let isFromUrl = false
  if (!loginData) {
    loginData = {}
    loginData.BusCrsCheckSum = searchParams.get('CHK') || ''
    loginData.intCompanyID = searchParams.get('C') || 0
    loginData.intBranchCityID = searchParams.get('CT') || 0
    loginData.intBranchID = searchParams.get('B') || 0
    loginData.intUserID = searchParams.get('U') || 0
    loginData.strCompanyName = searchParams.get('CN') || ''
    loginData.strCityName = searchParams.get('CTN') || 0
    loginData.strBranchName = searchParams.get('BN') || ''
    loginData.strUserName = searchParams.get('UN') || ''
    loginData.IsBranchAdmin = searchParams.get('IBA') || 0
    loginData.IsMTPLAdmin = searchParams.get('IMPTLA') || 0
    loginData.IsAdmin = searchParams.get('IA') || 0
    AllowViewAllBranchOfCityReport = searchParams.get('AllowViewAllBranchOfCityReport') || 0
    AllowViewAllBranchReport = searchParams.get('AllowViewAllBranchReport') || 0
    AllowBranchInchargeRights = searchParams.get('AllowBranchInchargeRights') || 0
    AllowExportExcel = searchParams.get('AllowExportExcel') || 0
    UseToPayAsCOD = searchParams.get('TPAsCOD') || 0
    DefaultCurrencyID = searchParams.get('DC') || 0
    UseFormattedLRinReports = searchParams.get('UFLR') || 0
    isFromUrl = true
  }
  const { intCompanyID, intUserID, strCompanyName } = loginData || {}
  const filterItemSx = isFromUrl ? sx.itemsxGrow : sx.itemsx
  const headerDataPDF = {
    toDate: toDate.format('DD-MMM-YYYY'),
    fromDate: fromDate.format('DD-MMM-YYYY'),
    selSourceCity: selSourceCity?.SourceCity,
    selSourceBranch: selSourceBranch?.SourceBranch,
    selDestinationCity: selDestinationCity?.DestinationCity,
    selDestinationBranch: selDestinationBranch?.DestinationBranch,
    paymentType: paymentType?.name,
    reportView: reportView?.view,
    reportOptions: reportOptions?.[0]?.optionId === 0 ? reportOptions[0].Option : 'Multi Selected',
    dataType: 'entry'
  }
  useEffect(() => {
    focusElemnt(id.anlsFromDate)
  }, [])
  useEffect(() => {
    if (isFromUrl && !isEmpty(roleRightsData) && !isEmpty(loginData)) {
      setDisableBtn(
        !(AllowViewAllBranchReport || AllowBranchInchargeRights || loginData?.IsBranchAdmin || loginData?.IsMTPLAdmin || loginData?.IsAdmin)
      )
      setDisableExcel(!AllowExportExcel)
    }
  }, [roleRightsData, loginData])

  const handleClick2 = () => {
    let url = urls.analysisReport
    const urlData = urls.analysisReportParams
    urlData.chk = loginData?.BusCrsCheckSum
    urlData.FromDate = fromDate.format('DD-MMM-YYYY')
    urlData.ToDate = toDate.format('DD-MMM-YYYY')
    urlData.LoginCompanyId = loginData?.intCompanyID
    urlData.LoginBranchId = loginData?.intBranchID
    urlData.FromCityId = selSourceCity.BookingCityID
    urlData.FromBranchId = selSourceBranch.BookingBranchID
    urlData.ToCityId = selDestinationCity.DestinationCityID
    urlData.ToBranchId = selDestinationBranch.DestinationBranchID
    urlData.PaymentMode = paymentType.typeId
    urlData.LoginUserId = loginData?.intUserID
    urlData.FromCityName = selSourceCity.SourceCity
    urlData.FromBranchName = selSourceBranch.SourceBranch
    urlData.DestCityName = selDestinationCity.DestinationCity
    urlData.DestBranchName = selDestinationBranch.DestinationBranch
    urlData.PaymentType = paymentType.name
    urlData.IsSummary = 0
    urlData.IsPaymentwise = reportOptions.find((item) => item?.optionId === 1) ? 1 : 0
    urlData.IsBookingCity = reportOptions.find((item) => item?.optionId === 2) ? 1 : 0
    urlData.IsBookingBranch = reportOptions.find((item) => item?.optionId === 3) ? 1 : 0
    urlData.IsDestBranch = reportOptions.find((item) => item?.optionId === 4) ? 1 : 0
    urlData.IsDestCity = reportOptions.find((item) => item?.optionId === 5) ? 1 : 0
    urlData.IsExtendedReport = reportView?.id == 1 ? 0 : 1
    url = appendToUrl(url, urlData)
    window.open(url, '_blank')
  }
  const callFilterAPi = () => {
    if (Math.abs(toDate.diff(fromDate, 'days')) > 31) {
      setAlert({ show: true, msg: 'This report cannot be taken for more than 31 days', nextId: '' })
    } else {
      const obj = {
        CompanyID: loginData?.intCompanyID,
        FromDate: fromDate.format('YYYY-MM-DD'),
        ToDate: toDate.format('YYYY-MM-DD'),
      }
      GetRequest(urls2.getAnalysisDropData, obj).then((res) => {
        if (res.status == 'Success') {
          if (res?.Data?.Table?.length > 0) {
            let data = []
            let data1 = []
            let data2 = []
            let data3 = []
            res.Data.Table?.map((val, i) => {
              data.push({ SourceCity: val?.SourceCity, BookingCityID: val?.BookingCityID })
              data1.push({ SourceBranch: val?.SourceBranch, BookingBranchID: val?.BookingBranchID, SourceCity: val?.SourceCity })
              data2.push({
                DestinationCity: val?.DestinationCity,
                DestinationCityID: val?.DestinationCityID,
                SourceCity: val.SourceCity,
              })
              data3.push({
                DestinationBranch: val?.DestinationBranch,
                DestinationBranchID: val?.DestinationBranchID,
                DestinationCity: val?.DestinationCity,
              })
            })
            setSourceCityData([{ SourceCity: 'All Cities', BookingCityID: 0 }, ...data])
            setSourceBranchData([{ SourceBranch: 'All Branches', BookingBranchID: 0 }, ...data1])
            setDestinationCityData([{ DestinationCity: 'All Cities', DestinationCityID: 0 }, ...data2])
            setDestinationBranchData([{ DestinationBranch: 'All Branch', DestinationBranchID: 0 }, ...data3])
            if (disableBtn) {
              setSelSourceCity({ SourceCity: loginData?.strCityName, BookingCityID: loginData?.intBranchCityID })
              setSelSourceBranch({ SourceBranch: loginData?.strBranchName, BookingBranchID: loginData?.intBranchID })
            } else {
              setSelSourceCity({ SourceCity: 'All Cities', BookingCityID: 0 })
              setSelSourceBranch({ SourceBranch: 'All Branches', BookingBranchID: 0 })
            }
            setSelDestinationCity({ DestinationCity: 'All Cities', DestinationCityID: 0 })
            setSelDestinationBranch({ DestinationBranch: 'All Branch', DestinationBranchID: 0 })
          } else {
            setSourceCityData([])
            setSourceBranchData([])
            setDestinationCityData([])
            setDestinationBranchData([])
            setSelSourceCity(' ')
            setSelSourceBranch(' ')
            setSelDestinationCity('  ')
            setSelDestinationBranch(' ')
          }
        } else {
          setAlert({ show: true, msg: 'No Data', nextId: '' })
        }
      })
    }
  }
  const handleClick1 = (isPdf = false) => {
    if (selSourceCity == '' || selSourceCity == ' ') {
      setAlert({ show: true, msg: 'Select Source City', nextId: '' })
    }
    if (selSourceBranch == '' || selSourceBranch == ' ') {
      setAlert({ show: true, msg: 'Select Source Branch', nextId: '' })
    } else if (Math.abs(toDate.diff(fromDate, 'days')) > 31) {
      setAlert({ show: true, msg: 'This report cannot be taken for more than 31 days', nextId: '' })
    } else {
      setLoader(true)
      const body = {
        intCompanyID: loginData?.intCompanyID,
        intBranchID: loginData?.intBranchID,
        intFromCityID: selSourceCity?.BookingCityID,
        intFromBranchID: selSourceBranch?.BookingBranchID,
        intToCityID: selDestinationCity?.DestinationCityID,
        intToBranchID: selDestinationBranch?.DestinationBranchID,
        PayTypeIDs: paymentType?.typeId,
        dtFromDate: fromDate.format('YYYY-MM-DD'),
        dtToDate: toDate.format('YYYY-MM-DD'),
        intUserID: loginData?.intUserID,
      }
      GetRequest(urls2.getAnalysisTableData, body).then((res) => {
        if (res.status == 'Success') {
          const updatedData = { ...res.Data };
          if (UseToPayAsCOD === 1) {
            if (Array.isArray(updatedData.Table1)) {
              updatedData.Table1 = updatedData.Table1.map(item =>
                item.PaymentType === 'TO-PAY'
                  ? { ...item, PaymentType: 'COD' }
                  : item
              );
            }
            if (Array.isArray(updatedData.Table6)) {
              updatedData.Table6 = updatedData.Table6.map(item =>
                item.PaymentType === 'TO-PAY'
                  ? { ...item, PaymentType: 'COD' }
                  : item
              );
            }
          }
          if (reportView?.id === 1) {
            summaryReportFormat(updatedData, isPdf);
          } else {
            if (updatedData?.Table.length === 0) {
              setAlert({ show: true, msg: 'No Data Found', nextId: '' })
              setLoader(false)
              return
            }
            const indicesToRemove = UseFormattedLRinReports === 3 ? [2] : UseFormattedLRinReports === 2 ? [1, 3] : [2, 3]
            const headerColumns = lrDetailsColumns.filter((_, index) => !indicesToRemove.includes(index))
            const viewHeader = headerColumns.map((a) => ({ ...a, weight: Number(a.width.replace('px', '')), field: a.field === 'Status' ? 'StatusView' : a.field, dataKey: a.field === 'Status' ? 'StatusView' : a.field, }))

            const formatedData = lrDetailsDataFormat(updatedData?.Table || [], headerColumns, headerDataPDF)

            const reportPayload = {
              reportName,
              criteriaHeaders: excelHeader,
              criteriaData: [headerDataPDF],
              tableData: formatedData,
              mainHeader: viewHeader,
              serialNokey: 'SN'
            }
            if (isPdf === true) {
              downloadPDF({
                reportName: reportName + ' Report',
                criteriaHeaders: excelHeader,
                criteriaData: [headerDataPDF],
                tableData: formatedData,
                visibleColumns: viewHeader,
                loginData,
                hideHeader: false
              })
              setLoader(false)
              return
            }
            const rid = Date.now().toString()
            if (!window.generatedReports) {
              window.generatedReports = {}
            }
            window.generatedReports[rid] = reportPayload
            setLoader(false)
            window.open(`/view-report?rid=${rid}`, "_blank")
          }

        } else {
          setAlert({ show: true, msg: 'No Data', nextId: '' })
          setLoader(false)
        }
      })
    }
  }

  const summaryReportFormat = (reporData, isPdf = false) => {
    let tables = []
    const updatedHeaderColumns =
      UseToPayAsCOD === 1
        ? headerColumns
          .map((col) => {
            switch (col.field) {
              case 'TotalToPay':
                return { ...col, headerName: 'COD', exportHead: 'COD' }
              case 'TotalToPayMan':
                return { ...col, headerName: 'COD Manual', exportHead: 'COD Manual' }
              case 'TotalToPayDDDV':
                return { ...col, headerName: 'COD DDDV', exportHead: 'COD DDDV' }
              default:
                return col
            }
          })
          .filter((col) => col.field !== 'TotalCOD')
        : headerColumns
    if (reportOptions.find((a) => a.optionId === 1) || reportOptions?.[0]?.optionId === 0) {
      const paymentWiseCol =
        DefaultCurrencyID === 2
          ? paymentWiseColumns.map((col) => (col.field === 'Valuation' ? { ...col, headerName: 'Insurance' } : col))
          : paymentWiseColumns
      const paymentHeader = [...paymentWiseCol]
      let Table1 = paymentWiseAddTotal(
        reporData.Table1.map((item, i) => ({ ...item, SN: i + 1, dataType: 'entry' })),
        headerDataPDF,
        'TOTAL: All Payment Types',
        paymentHeader
      )
      tables.push({
        reportName: "Payment Type Wise",
        tableData: Table1,
        mainHeader: paymentHeader.map((obj) => ({ ...obj, exportHead: obj.headerName, header: obj.headerName, dataKey: obj.field, textAlign: obj.align || 'left', weight: 30 }))
      })
    }
    if (reportOptions.find((a) => a.optionId === 2) || reportOptions?.[0]?.optionId === 0) {
      const sourceCityHeader = [SNCol, sourceCityCol, ...updatedHeaderColumns]

      let Table2 = addTotal(
        reporData.Table2.map((item, i) => ({ ...item, SN: i + 1, dataType: 'entry' })),
        headerDataPDF,
        'TOTAL: All Source Cities',
        sourceCityHeader
      )
      tables.push({
        reportName: "Source City Wise",
        tableData: Table2,
        mainHeader: sourceCityHeader.map((obj) => ({ ...obj, header: obj.headerName, dataKey: obj.field, textAlign: obj.align || 'left', weight: 30 }))
      })
    }
    if (reportOptions.find((a) => a.optionId === 3) || reportOptions?.[0]?.optionId === 0) {
      const sourceBranchHeader = [SNCol, sourceCityCol, sourceBranchCol, ...updatedHeaderColumns]

      let Table3 = addTotal(
        reporData.Table3.map((item, i) => ({ ...item, SN: i + 1, dataType: 'entry' })),
        headerDataPDF,
        'TOTAL: All Source Branches',
        sourceBranchHeader
      )
      tables.push({
        reportName: "Source Branch Wise",
        tableData: Table3,
        mainHeader: sourceBranchHeader.map((obj) => ({ ...obj, header: obj.headerName, dataKey: obj.field, textAlign: obj.align || 'left', weight: 30 }))
      })
    }
    if (reportOptions.find((a) => a.optionId === 4) || reportOptions?.[0]?.optionId === 0) {
      const destCityHeader = [SNCol, destCityCol, ...updatedHeaderColumns]
      let Table4 = addTotal(
        reporData.Table4.map((item, i) => ({ ...item, SN: i + 1, dataType: 'entry' })),
        headerDataPDF,
        'TOTAL: All Destination Cities',
        destCityHeader
      )
      tables.push({
        reportName: "Destination City Wise",
        tableData: Table4,
        mainHeader: destCityHeader.map((obj) => ({ ...obj, header: obj.headerName, dataKey: obj.field, textAlign: obj.align || 'left', weight: 30 }))
      })
    }
    if (reportOptions.find((a) => a.optionId === 5) || reportOptions?.[0]?.optionId === 0) {
      const destBranchHeader = [SNCol, destCityCol, destBranchCol, ...updatedHeaderColumns]

      let Table5 = addTotal(
        reporData.Table5.map((item, i) => ({ ...item, SN: i + 1, dataType: 'entry' })),
        headerDataPDF,
        'TOTAL: All Dest. Branches',
        destBranchHeader
      )
      tables.push({
        reportName: "Destination Branch Wise",
        tableData: Table5,
        mainHeader: destBranchHeader.map((obj) => ({ ...obj, header: obj.headerName, dataKey: obj.field, textAlign: obj.align || 'left', weight: 30 }))
      })
    }
    if (reportOptions.find((a) => a.optionId === 6) || reportOptions?.[0]?.optionId === 0) {
      const paymentWiseCol =
        DefaultCurrencyID === 2
          ? paymentWiseColumns.map((col) => (col.field === 'Valuation' ? { ...col, headerName: 'Insurance' } : col))
          : paymentWiseColumns
      const bookingDateWiseHeader = [...paymentWiseCol]

      let bookingWisedata = reporData?.Table6?.map((item) => ({
        ...item,
        dataType: 'entry',
        BookingDate: item.BookingDateTime?.split('T')?.[0],
      }))
      const updatedArray = groupData('BookingDate', bookingWisedata, headerDataPDF, bookingDateWiseHeader)
      tables.push({
        reportName: "Booking Date Wise",
        tableData: updatedArray,
        mainHeader: bookingDateWiseHeader.map((obj) => ({ ...obj, exportHead: obj.headerName, header: obj.headerName, dataKey: obj.field, textAlign: obj.align || 'left', weight: 30 }))
      })

    }
    tables[0] = {
      ...tables[0],
      criteriaHeaders: excelHeader,
      criteriaData: [headerDataPDF],
    }
    const reportPayload = {
      reportName,
      isMultiTable: true,
      tables: tables
    }
    if (isPdf === true) {
      const selectedTables = tables?.map((val, i) => ({
        reportName:val.reportName,
        tableData: val.tableData,
        visibleColumns: val.mainHeader,
        hideHeader: false,
      }))
      downloadMultiTablePDF({
        reportName,
        criteriaHeaders: excelHeader,
        criteriaData: [headerDataPDF],
        tables: selectedTables,
        loginData,
      })
      setLoader(false)
      return
    }
    const rid = Date.now().toString()
    if (!window.generatedReports) {
      window.generatedReports = {}
    }
    window.generatedReports[rid] = reportPayload
    setLoader(false)
    window.open(`/view-report?rid=${rid}`, "_blank")
  }
  const reset = () => {
    setFromDate(moment(new Date()))
    setToDate(moment(new Date()))
    setSelSourceCity('')
    setSelSourceBranch('')
    setSelDestinationCity('')
    setSelDestinationBranch('')
    setPaymentType(paymentModesWithAll?.[0])
    setReportView(reportViewData?.[1])
    setReportOptions(reportOptionDet)
    setReportOptionsData(reportOptionDet)
    setShowTable(false)
  }

  const selectedReportView = (value) => {
    setReportView(value)
    setShowTable(false)
    if (value?.id === 1) {
      setReportOptionsData(reportOptionSum)
      setReportOptions([reportOptionSum?.[0]])
    } else {
      setReportOptionsData(reportOptionDet)
      setReportOptions([reportOptionDet?.[0]])
    }
  }
  const tableShow = () => {
    let Table
    if (reportView?.id === 1) {
      Table = <SummaryReport headerData={headerDataPDF} tableData={showTableData} reportOptions={reportOptions} />
    } else {
      Table = <LRDetails headerData={headerDataPDF} tableData={showTableData?.Table} />
    }
    return Table
  }

  const selectedSourceCity = (obj) => {
    setSelSourceCity(obj)
    setShowTable(false)
    setSelSourceBranch(
      removeDuplicatesFromArray(sourceBranchData, 'BookingBranchID').filter(
        (val) => val.SourceCity === obj?.SourceCity || obj?.BookingCityID === 0 || val.BookingBranchID === 0
      )?.[0]
    )
  }
  const selectedDestCity = (obj) => {
    setSelDestinationCity(obj)
    setShowTable(false)
    setSelDestinationBranch(
      removeDuplicatesFromArray(destinationBranchData, 'DestinationBranchID').filter(
        (val) => val.DestinationCity === obj?.DestinationCity || obj?.DestinationCityID === 0 || val.DestinationBranchID === 0
      )?.[0]
    )
  }
  return (
    <>
      <Item sx={{ padding: '0' }} className="reports">
      {isFromUrl && <style>{`.global-header { display: none; } #root { zoom: 1.2; }`}</style>}
        {isFromUrl ? <></> :<ReportHeading reportName={reportName} />}
        <Box sx={sx.reportFlex}>
            {isFromUrl ? <></> : <>
          <Item sx={sx.itemsx}>
            <DropDownOA
              id={id.selectCompnay}
              label={lb.select_company}
              defaultvalue={loginData?.strCompanyName}
              disabled={true}
              minWidth="250px"
            />
          </Item>
          <Item sx={sx.itemsx} className="disabled-wrapper">
            <Button
              variant="contained"
              disabled={true}
              style={{ ...sx.fullHeight, ...sx.novp }}
              id={id.goButton}
              className="btn btn-primary"
            >
              GO
            </Button>
          </Item></>}
          <Item sx={filterItemSx} className="input--container bookingDatePicker">
            <Datepicker
              name={'from_collection_date'}
              value={fromDate}
              label={'From Booking Date'}
              id={id.anlsFromDate}
              dateChange={(date) => {
                setFromDate(date)
                setShowTable(false)
                focusElemnt(id.anlsToDate)
              }}
              width= {isFromUrl ?'100%':'160px'}
            />
          </Item>
          <Item sx={isFromUrl ? { ...sx.itemsxGrow, width: '60%' } : sx.itemsx} className="input--container bookingDatePicker">
            <Datepicker
              label={'To Booking Date'}
              value={toDate}
              id={id.anlsToDate}
              dateChange={(date) => {
                setToDate(date)
                setShowTable(false)
                focusElemnt(id.anlsGoButton)
              }}
              width= {isFromUrl ?'100%':'160px'}
            />
          </Item>
          <Item sx={sx.itemsx} className="disabled-wrapper">
            <Button
              variant="contained"
              style={{ ...sx.fullHeight, ...sx.novp }}
              className="btn btn-primary"
              onClick={callFilterAPi}
              id={id.anlsGoButton}
              onKeyDown={(e) => navigation3(e, id.anSourceCity, id.anlsToDate, callFilterAPi)}
            >
              GO
            </Button>
          </Item>
          <Item sx={filterItemSx} >
            <DropDownOA
              id={id.anSourceCity}
              label={'Source City'}
              searchPlaceholder={`Search Source City`}
              defaultvalue={selSourceCity?.SourceCity || selSourceCity}
              data={removeDuplicatesFromArray(sourceCityData, 'BookingCityID') || []}
              listWidth="200px"
              dataKey={`SourceCity`}
              idKey={`BookingCityID`}
              disabled={disableBtn}
              onSelect={(obj) => selectedSourceCity(obj)}
              nextId={id.anSourceBranch}
              prevId={id.anlsGoButton}
              width= {isFromUrl ?'100%':'170px'}
            />
          </Item>
          <Item sx={filterItemSx} >
            <DropDownOA
              id={id.anSourceBranch}
              label={'Source Branch'}
              searchPlaceholder={`Search Source Branch`}
              defaultvalue={selSourceBranch?.SourceBranch || selSourceBranch}
              data={
                removeDuplicatesFromArray(sourceBranchData, 'BookingBranchID').filter(
                  (val) => val.SourceCity === selSourceCity?.SourceCity || selSourceCity?.BookingCityID === 0 || val.BookingBranchID === 0
                ) || []
              }
              listWidth="200px"
              dataKey={`SourceBranch`}
              idKey={`BookingBranchID`}
              disabled={disableBtn && AllowViewAllBranchOfCityReport == 0}
              onSelect={(obj) => {
                setSelSourceBranch(obj)
                setShowTable(false)
              }}
              nextId={id.anDestinationCity}
              prevId={id.anSourceCity}
              width= {isFromUrl ?'100%':'170px'}
            />
          </Item>
          <Item sx={filterItemSx} >
            <DropDownOA
              id={id.anDestinationCity}
              label={'Destination City'}
              searchPlaceholder={`Search Destination City`}
              defaultvalue={selDestinationCity?.DestinationCity || selDestinationCity}
              data={
                removeDuplicatesFromArray(destinationCityData, 'DestinationCityID').filter(
                  (val) => val.DestinationCity !== selSourceCity?.SourceCity || val.DestinationCityID === 0
                ) || []
              }
              listWidth="200px"
              dataKey={`DestinationCity`}
              idKey={`DestinationCityID`}
              onSelect={(obj) => selectedDestCity(obj)}
              nextId={id.anDestinationBranch}
              prevId={id.anSourceBranch}
              width= {isFromUrl ?'100%':'170px'}
            />
          </Item>
          <Item sx={filterItemSx} >
            <DropDownOA
              id={id.anDestinationBranch}
              defaultvalue={selDestinationBranch?.DestinationBranch || selDestinationBranch}
              data={
                removeDuplicatesFromArray(destinationBranchData, 'DestinationBranchID').filter(
                  (val) =>
                    val.DestinationCity === selDestinationCity?.DestinationCity ||
                    selDestinationCity?.DestinationCityID === 0 ||
                    val.DestinationBranchID === 0
                ) || []
              }
              width="100%"
              searchPlaceholder={`Search Destination Branch`}
              label={'Destination Branch'}
              tabIndex="2"
              dataKey={`DestinationBranch`}
              idKey={`DestinationBranchID`}
              onSelect={(value) => {
                setSelDestinationBranch(value)
                setShowTable(false)
              }}
              nextId={id.anPaymentType}
              prevId={id.anDestinationCity}
              width= {isFromUrl ?'100%':'170px'}
            />
          </Item>
          <Item sx={filterItemSx} >
            <DropDownOA
              id={id.anPaymentType}
              data={
                (paymentModesWithAll || []).map((item) => {
                  if (UseToPayAsCOD === 1) {
                    if (item.typeId === 2) {
                      return { ...item, name: 'COD' };
                    }
                    if (item.typeId === 7) {
                      return { ...item, name: 'COD Manual' };
                    }
                    if (item.typeId === 9) {
                      return { ...item, name: 'COD DDDV' };
                    }
                    if (item.typeId === 4) {
                      return null;
                    }
                  }
                  return item;
                }).filter(Boolean)
              }
              defaultvalue={paymentType?.name}
              width="100%"
              searchPlaceholder={`Search By Payment Type`}
              label={'Payment Type'}
              tabIndex="2"
              dataKey={`name`}
              idKey={`typeId`}
              onSelect={(value) => {
                setPaymentType(value)
                setShowTable(false)
              }}
              nextId={id.anView}
              prevId={id.anDestinationBranch}
              width= {isFromUrl ?'100%':'170px'}
            />
          </Item>
          <Item sx={filterItemSx} >
            <DropDownOA
              id={id.anView}
              defaultvalue={reportView?.view}
              data={reportViewData}
              width="100%"
              searchPlaceholder={`Search By View`}
              label={'Report View'}
              tabIndex="2"
              dataKey={`view`}
              idKey={`id`}
              onSelect={(value) => selectedReportView(value)}
              nextId={id.anReportOptions}
              prevId={id.anPaymentType}
              width= {isFromUrl ?'100%':'170px'}
            />
          </Item>
          <Item  sx={filterItemSx}>
            <DropDownMultiSelectV2
              id={id.anReportOptions}
              data={reportOptionsData || []}
              defaultvalue={reportOptions}
              width="100%"
              HasAllSelect={true}
              searchPlaceholder={`Search By Report Options`}
              label={'Report Options'}
              tabIndex="2"
              dataKey={`Option`}
              idKey={`optionId`}
              listWidth="200px"
              limit={reportView?.id ? 200 : 1}
              onSelect={(value) => {
                setReportOptions(value)
                setShowTable(false)
              }}
              nextId={id.anSplitButton}
              prevId={id.anView}
              width= {isFromUrl ?'100%':'170px'}
            />
          </Item>
          {isFromUrl ?
            <Button variant="contained" sx={{ width: '100%', height: '40px', marginBottom: '10px' }} className="btn btn-primary" onClick={() => handleClick1(true)} id1={id.reportmainButton}>
              DOWNLOAD PDF
            </Button> :
            <>
          <Item
            sx={sx.itemsx}
            style={{ cursor: 'pointer' }}
            onKeyDown={(e) =>
              navigation3(
                e,
                showTable ? (disableExcel ? 'anaxportAsPdfBtn' : 'analsExpToExlbtn') : id.anlsFromDate,
                id.anReportOptions,
                () => handleClick1(false)
              )
            }
          >
            <SplitButton
              options={['GENERATE NEW FORMAT', 'GENERATE OLD FORMAT']}
              id1={id.anSplitButton}
              prevID={id.anReportOptions}
              onClick1={() => handleClick1(false)}
              onClick2={handleClick2}
            />
          </Item>
          <Item sx={{ ...sx.itemsx }} style={{ cursor: 'pointer' }} onClick={() => reset()}>
            <RefreshSvg width={'24px'} height={'24px'} />
          </Item></>}
        </Box>
      </Item>
      <Item>{showTable && tableShow()}</Item>
    </>
  )
}
const mapStateToProps = (data) => ({ data })
export default connect(mapStateToProps)(AnalysisReport)
